<div class="mx-10">
  <section class="container">
    <article
      class="flex flex-col md:flex-row items-left md:items-start max-w-full p-5 rounded-lg"
    >
      <!-- Seller Image -->
      <img
        class="w-24 h-24 md:w-32 mt-3 md:h-32 mb-4 mx-4 p-4 border-2 border-pink-500 shadow-md rounded-full shadow-md"
        src="assets/store-icon.png"
        alt="Vendor Image"
      />

      <!-- Seller Details -->
      <div class="flex-1">
        <div class="p-4 md:p-5">
          <div
            class="flex flex-col md:flex-row md:justify-between items-start md:items-center"
          >
            <div class="mb-4 md:mb-0 justify-between">
              <h2 class="text-lg md:text-xl text-gray-700 font-semibold">
                <span class="text-purple-700 text-2xl font-bold">{{
                  sellerStoreDetails?.storeName
                }}</span>
              </h2>
            </div>
          </div>

          <!-- Star Ratings -->
          <div class="flex flex-wrap mt-3">
            <ng-container *ngFor="let star of [1, 2, 3, 4, 5]; let i = index">
              <svg
                class="h-6 w-6"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
                [ngClass]="{
                  'text-yellow-500': star <= sellerAvgRating?.averageRating,
                  'text-gray-300': star > sellerAvgRating?.averageRating
                }"
              >
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                ></path>
              </svg>
            </ng-container>
            <span class="text-sm ml-2 text-gray-600">
              {{ sellerAvgRating?.averageRating || 0 }} / 5 - Last 12 months rating
            </span>
          </div>
          <button
            (click)="sellerAllProduct(sellerStoreDetails?.seller)"
            class="lg:mt-5 md:mt-0 p-4 py-2 text-violet-600 border border-violet-600 rounded hover:bg-violet-600 hover:text-white"
          >
            View Store
          </button>
        </div>
        <!-- About Section -->
        <h3 class="ml-4 text-lg md:text-xl font-bold">About Us</h3>
        <p class="p-4 md:p-6 text-gray-600">
          {{ sellerStoreDetails?.storeDescription }}
        </p>
      </div>
    </article>
  </section>

  <div
    *ngIf="sellerStoreReviews?.length > 0"
    class="relative flex flex-col md:flex-row justify-between items-center p-5 mx-10 border-b"
  >
    <h2 class="text-xl md:text-2xl font-bold mb-4 md:mb-0">
      Verified Reviews for
      <span class="text-blue-500">{{ sellerStoreDetails?.storeName }}</span>
    </h2>
    <p
      class="font-bold text-lg md:text-2xl underline cursor-pointer md:absolute md:right-10"
    >
      See More
    </p>
  </div>

  <!-- Reviews Section -->
  <div class="mx-10">
    <!-- If there are reviews -->
    <div *ngIf="sellerStoreReviews && sellerStoreReviews.length > 0">
      <div
        class="border-t-2 border-purple-700 p-5 m-5 rounded-lg shadow-md bg-white"
        *ngFor="let item of sellerStoreReviews"
      >
        <div class="flex flex-col md:flex-row items-start">
          <!-- Reviewer Image -->
          <div
            class="relative w-20 h-20 md:w-24 md:h-24 rounded-full overflow-hidden"
          >
            <img
              class="absolute top-0 left-0 w-full h-full object-cover"
              [src]="vendorProductImageUrl + item?.user.profileImage"
              alt="Profile picture"
            />
          </div>

          <!-- Review Content -->
          <div class="ml-4 md:ml-6 flex-1">
            <p class="flex items-baseline">
              <span class="text-gray-700 font-bold text-2xl">{{
                item?.user?.name
              }}</span>
              <span class="ml-2 text-green-600 text-xs">Verified Buyer</span>
            </p>

            <!-- Star Ratings -->
            <div class="flex flex-wrap mt-3">
              <ng-container *ngFor="let star of [1, 2, 3, 4, 5]; let i = index">
                <svg
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  [ngClass]="{
                    'text-yellow-500': star <= item?.rating,
                    'text-gray-300': star > item?.rating
                  }"
                >
                  <path
                    d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
                  ></path>
                </svg>
              </ng-container>
            </div>

            <div class="mt-3">
              <p class="mt-1 text-gray-600 text-lg font-semibold truncate">
                {{ item?.reviewText }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- If there are no reviews -->
    <div
      *ngIf="sellerStoreReviews?.length === 0"
      class="text-center text-gray-600 text-xl font-semibold p-10"
    >
      No reviews found.
    </div>
  </div>

  <div
    class="max-w-screen-xl mx-auto p-4 sm:p-6 md:p-8 border-2 border-purple-700 m-4 mx-10 sm:m-5 rounded-lg"
  >
    <h1
      class="text-lg sm:text-xl font-bold mb-4 flex justify-between items-center"
    >
      Popular Product from
      <b class="text-purple-700 mr-auto">
        &nbsp;{{ sellerStoreDetails?.storeName }}</b
      >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6 sm:h-7 sm:w-7 bg-purple-700 rounded-full"
        fill="white"
        viewBox="0 0 512 512"
      >
        <path
          fill-rule="evenodd"
          d="M0 256c0 70.68 28.66 134.7 74.98 181.02C121.3 483.34 185.32 512 256 512c70.69 0 134.7-28.66 181.02-74.98C483.34 390.7 512 326.69 512 256c0-70.69-28.66-134.7-74.98-181.02C390.7 28.66 326.69 0 256 0 185.32 0 121.3 28.66 74.98 74.98 28.66 121.3 0 185.31 0 256zm231.67-109.04L340.7 256 231.67 365.04l-40.52-40.51 68.51-68.52-68.52-68.52 40.53-40.53zM101.01 410.99c-39.66-39.66-64.2-94.47-64.2-154.99 0-60.53 24.54-115.33 64.2-154.99 39.66-39.66 94.47-64.2 154.99-64.2 60.53 0 115.33 24.54 154.99 64.2 39.66 39.66 64.2 94.46 64.2 154.99 0 60.53-24.54 115.33-64.2 154.99-39.66 39.66-94.46 64.2-154.99 64.2-60.52 0-115.33-24.54-154.99-64.2z"
        />
      </svg>
    </h1>

    <div
      class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-6"
    >
      <app-product
        *ngFor="let product of sellerProducts"
        [product]="product"
        class="inline-block w-64 min-w-64"
      ></app-product>
    </div>
  </div>
</div>
